// src/pages/PurchaseReturnLedger/PurchaseReturnLedgerSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchPurchaseReturnLedger,
  fetchPurchaseReturnAccounts,
} from "./PurchaseReturnLedgerThunk";

const initialState = {
  list: [],
  accounts: [],
  loading: false,
  filters: {
    accId: null,
    fromDate: null,
    toDate: null,
  },
};

const purchaseReturnLedgerSlice = createSlice({
  name: "purchaseReturnLedger",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPurchaseReturnLedger.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPurchaseReturnLedger.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchPurchaseReturnLedger.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchPurchaseReturnAccounts.fulfilled, (state, action) => {
        state.accounts = action.payload;
      });
  },
});

export const { setFilters } = purchaseReturnLedgerSlice.actions;
export default purchaseReturnLedgerSlice.reducer;
